import React from 'react'
import { connect } from 'react-redux'
import { Box, Typography } from '@mui/material'
import { chanceText } from '../../lib/rule'
import ShareButtonHelp from '../rule-help/ShareButtonHelp'
import NaidesuHelp from '../rule-help/NaidesuHelp'
import './RuleDisplay.scss'

const ButtonRule = ({ simple, rule, summary: { numPlayers } }) => {
  const list = [(
    <Box component="span" className="rule-element" key="chance">
      {chanceText(simple, rule, numPlayers)}
    </Box>
  ), (
    rule.team.active && rule.team.shareButton &&
    <Box component="span" className="rule-element" key="share-button">
      チームでボタンを共有<ShareButtonHelp size="small" />
    </Box>
  ), (
    rule.right.nextPlayer &&
    <Box component="span" className="rule-element" key="next-player">
      正解時に次の人に解答権
    </Box>
  ), (
    rule.right.naidesu &&
    <Box component="span" className="rule-element" key="naidesu">
      Naidesu<NaidesuHelp size="small" />
    </Box>
  )].filter(e => e)

  return (
    <Box className="button-rule">
      <Typography variant="caption">
        <Box component="span" className="rule-caption">ボタン</Box>
      </Typography>
      <Typography variant="body2" className="content">
        {list}
      </Typography>
    </Box>
  )
}

export default connect(
  state => ({
    summary: state.summary
  })
)(ButtonRule)
